import type { UseControllerProps } from "react-hook-form";

import { useController, useFormContext, useWatch } from "react-hook-form";
import { TextActionOptional } from "src/features/observations/components/TextActionOptional";

interface RadioQuestionProps extends UseControllerProps<ObservationFormState> {
	questionNumber: number;

	answers: ObservationAnswer[];

	staticInput?: boolean;

	showAction?: boolean;
}

const RadioQuestion = ({
	name,
	rules,
	questionNumber,
	answers,
	staticInput,
	showAction
}: RadioQuestionProps) => {
	const { control } = useFormContext<ObservationFormState>();

	const {
		field: { onChange, value, ...restField }
	} = useController({
		control,
		name,
		rules
	});

	const { isDisabled } = useWatch({
		control
	});

	const handleChange = (nextValue: string) => {
		if (staticInput) return;

		onChange(nextValue);
	};

	return (
		<>
			<div
				id={`question-${questionNumber}`}
				role="radiogroup"
				className="mt-4 flex flex-col gap-4"
				aria-disabled={isDisabled}
			>
				{answers.map(({ name: answerName, uuid }) => (
					<div key={uuid} className="flex items-center w-full">
						<label className="flex items-center gap-2 cursor-pointer w-full">
							<input
								type="radio"
								value={answerName}
								checked={value === answerName}
								onChange={() => handleChange(answerName)}
								disabled={isDisabled}
								className="accent-foreground"
							/>
							<span>{answerName}</span>
						</label>
					</div>
				))}
			</div>

			{showAction && (
				<TextActionOptional
					name={`questions.${questionNumber - 1}.action`}
					questionNumber={questionNumber}
					staticInput={staticInput}
				/>
			)}
		</>
	);
};

export { RadioQuestion, type RadioQuestionProps };
